import React, { ReactNode, useEffect, useState } from 'react';
import LinkService from '../../system/LinkService';
import useApiCall from '../../system/useApiCall';
import StandardTable from '../../common/Component/StandardTable';
import { GridColumns, GridRenderCellParams, GridRowsProp } from '@mui/x-data-grid';
import WuParticipantModTO from '../TO/WuParticipantModTO';
import DropdownTO from '../../common/TO/DropdownTO';
import { MenuItem, Select } from '@mui/material';
import TableUtil from '../../system/TableUtil';
import { useWuEventDropdownData } from '../Helper/WuHelperHooks';

export default function WuEventLivePage() {
  const [editRow, setEditRow] = useState<number | null>(null);
  const [openDataDialog, setOpenDataDialog] = useState<boolean>(false);
  const [saveCount, setSaveCount] = useState<number>(0);
  const [wuParticipantList, setWuParticipantList] = useState<WuParticipantModTO[]>([]);
  const [selectedWuEvent, setSelectedWuEvent] = useState<number>(-1);
  const [causeOfDeathDropdownList, setCauseOfDeathDropdownList] = useState<DropdownTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();
  const wuEventDropdownData = useWuEventDropdownData();

  useEffect(() => {
    getCauseOfDeathDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (wuEventDropdownData.length > 0) {
      getWuEventActiveId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wuEventDropdownData.length]);

  useEffect(() => {
    getWuParticipants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCount, selectedWuEvent]);

  useEffect(() => {
    if (editRow === null && openDataDialog) {
      setOpenDataDialog(false);
    } else if (editRow !== null && !openDataDialog) {
      setOpenDataDialog(true);
    }
  }, [editRow, openDataDialog]);

  const getWuParticipants = () => {
    if (selectedWuEvent > -1) {
      setIsLoading(true);
      apiCall.get(LinkService.wuParticipantsByWuEventId(selectedWuEvent)).then((data) => {
        if (data) {
          const list: WuParticipantModTO[] = data;
          setWuParticipantList(list);
          setIsLoading(false);
        }
      });
    }
  };

  const getWuEventActiveId = () => {
    apiCall.get(LinkService.wuEventActiveId()).then((data) => {
      if (data) {
        const eventId: number = data;
        setSelectedWuEvent(eventId);
      }
    });
  };

  const getCauseOfDeathDropdown = () => {
    apiCall.get(LinkService.dropdownCauseOfDeath()).then((data) => {
      if (data) {
        const list: DropdownTO[] = data;
        setCauseOfDeathDropdownList(list);
      }
    });
  };

  const getEditDataById = (id: number) => {
    const wuParticipantData = wuParticipantList.find((item: WuParticipantModTO) => item.id === id);
    return wuParticipantData;
  };

  const renderCauseOfDeath = (params: GridRenderCellParams<any, any, any>): ReactNode => {
    return (
      <Select
        margin='dense'
        id='role'
        label='Rolle'
        fullWidth
        variant='standard'
        value={params.value !== null ? params.value : ''}
        onChange={(e) => {
          const wuParticipantData = getEditDataById(params.row.id);
          wuParticipantData!.causeOfDeath = e.target.value ? e.target.value : null;
          apiCall.post(LinkService.wuParticipantPost(), wuParticipantData, 'Speichern erfolgreich.').then((data) => {
            setSaveCount(saveCount + 1);
          });
        }}
      >
        <MenuItem key={'causeOfDeathDropdown_empty'} value={''}>
          {'- lebt -'}
        </MenuItem>
        {causeOfDeathDropdownList.map((dropdownItem: DropdownTO) => (
          <MenuItem key={'causeOfDeathDropdown_' + dropdownItem.id} value={dropdownItem.id}>
            {dropdownItem.name}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const columns: GridColumns = [
    { field: 'id', headerName: 'Nr.', type: 'number', width: 40, editable: false },
    { field: 'twitchname', headerName: 'Twitch-Name', flex: 1, editable: false },
    { field: 'household', headerName: 'Haushalt', flex: 1, editable: false },
    { field: 'nameOfSim', headerName: 'Sim-Name', flex: 1, editable: false },
    { field: 'team', headerName: 'Team', flex: 1, editable: false },
    { field: 'comment', headerName: 'Kommentar', flex: 1, editable: false },
    { field: 'causeOfDeath', headerName: 'Todesursache', flex: 1, editable: false, renderCell: renderCauseOfDeath },
    {
      field: 'dateOfDeath',
      headerName: 'Todeszeitpunkt',
      flex: 1,
      editable: false,
      valueFormatter: TableUtil.formatDateCell,
    },
  ];

  const rows: GridRowsProp = [...wuParticipantList];

  return (
    <div>
      <Select
        margin='dense'
        id='wuevent'
        label='WÜ Event'
        variant='standard'
        value={selectedWuEvent}
        onChange={(e) => setSelectedWuEvent(e.target.value as number)}
      >
        <MenuItem key={'wuDropdown_please_choose'} value={-1}>
          Event auswählen
        </MenuItem>
        {wuEventDropdownData.map((dropdownItem: DropdownTO) => (
          <MenuItem key={'wuDropdown_' + dropdownItem.id} value={dropdownItem.id}>
            {dropdownItem.name}
          </MenuItem>
        ))}
      </Select>
      <StandardTable
        saveURL={LinkService.wuEventPost()}
        editRowNumber={setEditRow}
        columns={columns}
        rows={rows}
        hideToolbar={true}
        hideActions={true}
        isLoading={isLoading}
      />
    </div>
  );
}
